import React from 'react';
import { ArrowRight, Shield, Award, Leaf } from 'lucide-react';
import { Button } from './ui/button';
import { companyInfo } from '../data/mock';

const HeroSection = () => {
  const scrollToSection = (e, href) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="home"
      className="relative min-h-screen flex items-center justify-center overflow-hidden">

      {/* Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://images.pexels.com/photos/5463582/pexels-photo-5463582.jpeg?auto=compress&cs=tinysrgb&w=1920')`
        }} />

      
      {/* Overlay */}
      <div className="absolute inset-0 hero-overlay" />
      
      {/* Decorative elements */}
      <div className="absolute top-20 left-10 w-72 h-72 bg-sky-500/10 rounded-full blur-3xl" />
      <div className="absolute bottom-20 right-10 w-96 h-96 bg-sky-400/10 rounded-full blur-3xl" />

      {/* Content */}
      <div className="relative z-10 container mx-auto px-4 sm:px-6 lg:px-8 pt-24">
        <div className="max-w-4xl mx-auto text-center">
          {/* Certification badges */}
          <div className="flex justify-center animate-fade-in-up !mt-[70px] !mb-[32px] !gap-[12px]">
            <span className="inline-flex items-center gap-2 px-4 py-2 bg-white/10 backdrop-blur-sm rounded-full text-white/90 text-sm font-medium border border-white/20">
              <Shield size={16} className="text-sky-400" />
              Certificati AIISA
            </span>
            <span className="inline-flex items-center gap-2 px-4 py-2 bg-white/10 backdrop-blur-sm rounded-full text-white/90 text-sm font-medium border border-white/20">
              <Award size={16} className="text-sky-400" />
              Standard NADCA
            </span>
          </div>

          {/* Main heading */}
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-6 animate-fade-in-up animation-delay-200">
            Benvenuti su
            <br />
            <span className="text-sky-400">{companyInfo.name}</span>
          </h1>

          {/* Subheading */}
          <p className="text-xl sm:text-2xl text-white/80 mb-8 max-w-3xl mx-auto animate-fade-in-up animation-delay-400">
            {companyInfo.tagline}
          </p>

          {/* Description */}
          <p className="text-lg text-white/70 mb-10 max-w-2xl mx-auto animate-fade-in-up animation-delay-600">
            Offriamo soluzioni innovative e personalizzate per garantire ambienti di lavoro sani, sicuri ed efficienti.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center animate-fade-in-up animation-delay-600">
            <Button
              size="lg"
              onClick={(e) => scrollToSection(e, '#contatti')}
              className="bg-sky-500 hover:bg-sky-400 text-white px-8 py-6 text-lg font-semibold shadow-lg shadow-sky-500/30 hover:shadow-sky-400/40">

              Contattaci
              <ArrowRight className="ml-2" size={20} />
            </Button>
            <Button
              size="lg"
              variant="outline"
              onClick={(e) => scrollToSection(e, '#servizi')}
              className="border-2 border-white/30 text-white hover:bg-white/10 px-8 py-6 text-lg font-semibold backdrop-blur-sm">

              Scopri i Servizi
            </Button>
          </div>

          {/* Trust indicators */}
          <div className="mt-16 grid grid-cols-1 sm:grid-cols-3 gap-6 max-w-3xl mx-auto animate-fade-in-up animation-delay-600">
            <div className="flex flex-col items-center p-4 bg-white/5 backdrop-blur-sm rounded-xl border border-white/10">
              <div className="text-3xl font-bold text-sky-400 mb-1">20%</div>
              <div className="text-sm text-white/70">Risparmio Energetico</div>
            </div>
            <div className="flex flex-col items-center p-4 bg-white/5 backdrop-blur-sm rounded-xl border border-white/10">
              <div className="text-3xl font-bold text-sky-400 mb-1">50%</div>
              <div className="text-sm text-white/70">Vita Impianto +</div>
            </div>
            <div className="flex flex-col items-center p-4 bg-white/5 backdrop-blur-sm rounded-xl border border-white/10">
              <div className="text-3xl font-bold text-sky-400 mb-1">40%</div>
              <div className="text-sm text-white/70">Meno Riparazioni</div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-white/30 rounded-full flex justify-center pt-2">
          <div className="w-1.5 h-3 bg-white/50 rounded-full animate-pulse-slow" />
        </div>
      </div>
    </section>);

};

export default HeroSection;